import { colorPalette } from 'core/layouts/ui-blocks/ColorPalette';
import { tabletBreakpoint } from 'core/layouts/ui-blocks/ReusableStyles';

const imageDimension = 'min(40vw, 60vh)';
const imageDimensionMobile = '70vw';

export const homePromptsModalStyles = {
	modalWrapper: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',

		outline: 'none',
	},
	modalBody: {
		maxHeight: { xs: 'fit-content', [tabletBreakpoint]: '80vh' },

		display: 'flex',
		alignItems: 'center',
		gap: '16px',

		position: 'relative',
	},
	crossButton: {
		position: 'absolute',
		top: 0,
		right: 0,

		minWidth: 'unset',
		padding: 0,

		transform: 'translate(50%, -100%)',
		zIndex: 1,

		'& svg': {
			stroke: colorPalette.light2,

			height: '32px',
			width: 'auto',
		},
		'&.Mui-disabled': {
			'& svg': {
				stroke: colorPalette.light5,
			},
		},
	},

	arrowButton: {
		cursor: 'pointer',

		'& svg': { height: { xs: '24px', [tabletBreakpoint]: '40px' }, width: 'auto' },
	},

	contentWrapper: {
		maxHeight: '80vh',

		backgroundColor: 'colors.dark6',

		overflow: { xs: 'auto', [tabletBreakpoint]: 'hidden' },
	},
	content: {
		flexDirection: { xs: 'column', [tabletBreakpoint]: 'row' },
		alignItems: 'stretch',
	},

	imgWrapper: {
		flexShrink: 0,
		width: { xs: imageDimensionMobile, [tabletBreakpoint]: imageDimension },
		height: { xs: imageDimensionMobile, [tabletBreakpoint]: imageDimension },
	},
	imgCont: {
		width: '100%',
		paddingTop: '100%',

		position: 'relative',
	},
	image: {
		position: 'absolute',
		top: 0,
		right: 0,
		bottom: 0,
		left: 0,

		overflow: 'hidden',

		'& img': {
			height: '100%',
			width: '100%',
			objectFit: 'contain',
		},
	},

	promptDetailsCont: {
		width: { xs: '100%', [tabletBreakpoint]: 'min(25vw, 40vh)' },
		height: { xs: 'fit-content', [tabletBreakpoint]: imageDimension },

		display: 'flex',
		flexDirection: 'column',

		overflow: 'hidden',
	},
	promptDetailsScrollWrapper: {
		flexGrow: 1,
		overflow: 'scroll',
	},
	promptDetails: {
		padding: { xs: '16px 8px', [tabletBreakpoint]: '8px 10px 24px 24px' },

		display: 'flex',
		flexDirection: 'column',
		gap: '24px',
	},

	controlnetFacelockSection: {
		card: {
			padding: '12px',
			borderRadius: '4px',

			backgroundColor: 'colors.dark4',

			display: 'flex',
			flexDirection: 'column',
			alignItems: 'start',
		},
		subCard: {
			padding: '12px',
			borderRadius: '4px',
			border: `1px solid ${colorPalette.dark1}`,

			backgroundColor: 'colors.dark2',

			display: 'flex',
			alignItems: 'center',
			gap: '12px',

			cursor: 'pointer',

			'& svg': { height: '24px', width: 'auto' },
		},
	},

	creatorImg: {
		flexShrink: 0,
		height: '16px',
		width: '16px',
		borderRadius: '50%',

		backgroundColor: 'colors.light5',

		overflow: 'hidden',

		'& img': {
			height: '100%',
			width: '100%',
			objectFit: 'cover',
		},
	},
	creatorDetails: {
		maxWidth: '100%',
		textWrap: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	},

	divider: {
		width: '100%',
		borderBottom: `1px solid ${colorPalette.dark1}`,
	},

	detailCard: {
		width: '100%',
		padding: '12px',
		borderRadius: '4px',

		backgroundColor: 'colors.dark5',

		display: 'flex',
		flexDirection: 'column',
		gap: '24px',
	},
	detailCardModelImage: {
		height: '24px',
		width: '24px',
		borderRadius: '50%',

		overflow: 'hidden',

		'& img': { height: '100%', width: '100%', objectFit: 'cover' },
	},

	copyDetailButton: {
		display: 'flex',

		cursor: 'pointer',

		'& svg': {
			height: '16px',
			width: 'auto',
		},
	},
	detailValue: {
		width: '100%',

		display: 'flex',
		alignItems: 'center',
		gap: '4px',

		'& svg': { fill: colorPalette.light5 },
	},

	buttonsCont: {
		padding: '16px 16px 24px',
		borderTop: `1px solid ${colorPalette.dark4}`,

		backgroundColor: 'colors.dark5',

		display: 'flex',
		flexDirection: 'column',
		gap: '16px',
	},
	buttonsContRow1: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
	},
	likedComp: {
		display: 'flex',
		alignItems: 'center',
		gap: '4px',

		cursor: 'pointer',

		'&svg': {
			height: '24px',
			width: 'auto',
			flexShrink: 0,
		},
	},
	moveToStudioButton: {
		width: '100%',
		padding: '10px 16px',
		borderRadius: '4px',

		backgroundColor: 'colors.light1',
		textTransform: 'none',

		display: 'flex',
		alignItems: 'center',
		gap: '4px',

		'&:hover': { backgroundColor: 'colors.light1' },
	},

	useImageButtonSection: {
		width: '100%',
		marginTop: '16px',
		display: 'grid',
		gridTemplateColumns: {
			xs: 'repeat(auto-fill, minmax(150px, 1fr))',
			[tabletBreakpoint]: 'repeat(auto-fill, minmax(150px, 1fr))',
		},
		gridTemplateRows: 'auto',
		gridGap: '8px',
	},
};
